;(function () {

  //Sometimes a page can be accessed that has no declared parents, thereby making li.active count = 0.
  //Don't show the navigation in this case.
  var enabled = jQuery('.ateed-dormant-navigation > li.active')[0];

  window.Ateed.Components.HeaderMicro.MenuHelper = function() {
    var self = this;
    var data = createTree();
    self.tree = data[0];
    self.levels = createLevels(data);
    self.current = data[2];
    self.enabled = enabled;
  };

  var createTree = function() {
    var maxDepth = -1;
    var maxActiveDepth = -1;
    var tree = {
      uri: '/',
      title: 'Home',
      children: []
    };
    var currentNode; //(Current page), inferred by deepest node in tree with .active
    traverse($('.ateed-dormant-navigation').find('> li'), tree, 1);
    function traverse($lis, parent, depth) {
      $lis.each(function() {
        var $li = $(this);
        var $a = $li.find('> a');
        var node = {
          isActive: $li.hasClass('active'),
          uri: $a.attr('href'),
          title: $a.text().trim(),
          children: [],
          parent: parent,
          depth: depth,
          imageCards: $li.find('> .image-cards').length > 0 ? $($li.find('> .image-cards')[0]).html() : null,
          isVisible: true //default
        };

        parent.children.push(node);
        if(node.isActive && depth >= maxActiveDepth) {
          currentNode = node;
        }
        var $ul = $li.find('> ul');
        if($ul[0]) {
          if(depth >= maxDepth) {
            maxDepth = depth;
          }
          traverse($ul.find('> li'), node, depth + 1);
        }
      });
    }
    return [tree, maxDepth, currentNode];
  }

  var createLevels = function(data) {

    var tree = data[0];
    var depth = data[1];

    var levels = [];
    if(enabled) {
      //Populate level 1 immediately
      levels.push(new Ateed.MenuLevel(null, tree, 1, false));
      //Populate level 2 immediately
      levels.push(new Ateed.MenuLevel(tree, tree.children.filter(function(child) { return child.isActive === true; }).pop(), 2, true));
    }
    //Create empty levels (as levels > 3 are only populated after user interaction)
    for(var k=3; k<depth+1; k++) {

      levels.push(new Ateed.MenuLevel(null, {
        title: '',
        uri: '',
        links: [],
        number: k,
        parent: { title: '', uri: ''},
        children: []
      }, k, false));

      /*
      levels.push({
        title: '',
        uri: '',
        links: [],
        number: k,
        parent: { title: '', uri: ''},
        children: []
      });
      */
    }
    return levels;
  };


})();
